import { ReactNode } from 'react';
import { Locale } from '@core/constants/locales.constants';
import { Link } from '@graphql/__generated__/graphql';
import { LinkProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { generateInternalLinkUrl } from '@utils/paths/generateInternalLinkUrl.utils';
import { sanitiseLinkPropsForHTMLAnchor } from '@utils/paths/path.utils';

export const linkTransform = (
  link: CleanContentful<Link>,
  locale: Locale,
  iconAfter?: ReactNode,
  iconBefore?: ReactNode
): LinkProps => {
  if (!link) {
    throw new Error(`linkTransform: no link provided`);
  }

  const parsedLink = generateInternalLinkUrl(link, locale);

  if (!parsedLink) {
    console.error(link.id);
    throw new Error(`linkTransform: the provided link does not have a URL`);
  }

  const url = parsedLink.url || link.url || link.externalLink;

  if (!url) {
    throw new Error(`linkTransform: the provided link does not have a URL`);
  }

  return {
    ...sanitiseLinkPropsForHTMLAnchor(link),
    title: link?.title || '',
    url,
    useNext: true,
    iconAfter,
    iconBefore,
  };
};
